module.exports = __webpack_public_path__ + "img/seven2Blue.20a06fbd.jpg";